export default __webpack_public_path__ + "static/media/Python.443dc484.png";